import { LoginIntent } from "./../enums/LoginIntent";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiEndpointResolver, IsEcom } from "./apiEndpointResolver";
import HttpClient from "./httpClient";
import ConfigPropService from "./configPropService";
import ConfigProps from "../constants/configProps";
import UrlService from "./urlService";

let _preLoadedLoginUrl: string = "";
let _preLoadedRegistrationUrl: string = "";
let _preLoadedSwitchAccountUrl: string = "";

export function setPreLoadedLoginUrl(preLoadedLoginUrl: string) {
  _preLoadedLoginUrl = preLoadedLoginUrl;
}

export function setPreLoadedRegistrationUrl(preLoadedRegistrationUrl: string) {
  _preLoadedRegistrationUrl = preLoadedRegistrationUrl;
}

export function setPreLoadedSwitchAccountUrl(
  preLoadedSwitchAccountUrl: string,
) {
  _preLoadedSwitchAccountUrl = preLoadedSwitchAccountUrl;
}

const LoginUrlService = {
  get(loginIntent?: LoginIntent): Observable<string> {
    if (IsEcom()) {
      return ConfigPropService.get([
        ConfigProps.UseExternalIdentityProvider,
      ]).pipe(
        map((configProps) => {
          if (
            ConfigPropService.isYesOrTrue(
              configProps[ConfigProps.UseExternalIdentityProvider],
            )
          ) {
            return LoginUrlService.getPreLoadedLoginUrl();
          } else {
            let append = "";

            if (loginIntent === LoginIntent.Checkout) {
              append = "redirectTarget=1";
            } else if (loginIntent === LoginIntent.OnlineInvoicing) {
              append = "redirectTarget=0";
            } else if (loginIntent === LoginIntent.ChangeCartAddress) {
              append = "redirectTarget=2";
            }

            return LoginUrlService.getPreLoadedLoginUrl() + append;
          }
        }),
      );
    }

    const redirectUrl = UrlService.getNormalizedCurrentUrl();
    let baseUri = `${ApiEndpointResolver.getLoginUrl()}?redirectUrl=${encodeURIComponent(
      redirectUrl,
    )}`;

    if (loginIntent) {
      baseUri += `&loginIntent=${loginIntent}`;
    }

    return HttpClient.get({
      baseUri: baseUri,
    });
  },
  getPreLoadedLoginUrl(): string {
    return _preLoadedLoginUrl;
  },
  getPreLoadedRegistrationUrl(): string {
    return _preLoadedRegistrationUrl;
  },
  getPreLoadedSwitchAccountUrl(): string {
    return _preLoadedSwitchAccountUrl;
  },
};

export default LoginUrlService;
